import { gql } from '@apollo/client'

const FRAGMENT_REPLY = gql`
  fragment reply on Reply {
    id
    text
    from {
      username
      isChannel
    }
    createdAt
    needsAttention
    error {
      type
      draft
      code
    }
    labels
    status
    attachment {
      type
      url
    }
  }
`

const FRAGMENT_COMMENT = gql`
  fragment comment on Comment {
    id
    text
    from {
      username
      isChannel
    }
    createdAt
    replies {
      ...reply
    }
    needsAttention
    error {
      type
      draft
      code
    }
    labels
    status
    attachment {
      type
      url
    }
  }
  ${FRAGMENT_REPLY}
`

const FRAGMENT_MUTATION_RESPONSE = gql`
  fragment mutationResponse on EngagementMutationResponse {
    code
    success
    message
    post {
      totalPendingComments
      labelsCount {
        label
        count
      }
      commentsUpdatedAt
    }
    comment {
      id
      needsAttention
      error {
        type
        draft
        code
      }
      status
    }
    reply {
      id
      needsAttention
      error {
        type
        draft
        code
      }
      status
    }
    replySent {
      ...reply
    }
    channel {
      totalPendingComments
      labelsCount {
        label
        count
      }
    }
  }
  ${FRAGMENT_REPLY}
`

export const QUERY_POST = gql`
  query engagePost($id: String!, $refreshMedia: Boolean) {
    engagePost(id: $id, refreshMedia: $refreshMedia) {
      id
      text
      mediaUrl
      permalink
      totalLikes
      totalComments
      totalPendingComments
      channelService
      channelServiceId
      backfilling
      isGiveaway
      dismissingAll
      comments {
        ...comment
      }
      labelsCount {
        label
        count
      }
      createdAt
      commentsUpdatedAt
    }
  }
  ${FRAGMENT_COMMENT}
`

/**
 * TODO: Can't we make this following mutations the same one? In
 * the end it's just processing and un-processing of comments.
 */
export const MUTATION_REPLY = gql`
  mutation engageReply($postId: String!, $commentId: String!, $text: String!) {
    engageReply(postId: $postId, commentId: $commentId, text: $text) {
      ...mutationResponse
    }
  }
  ${FRAGMENT_MUTATION_RESPONSE}
`

export const MUTATION_DISMISS_COMMENT = gql`
  mutation engageDismiss($postId: String!, $commentId: String!) {
    engageDismiss(postId: $postId, commentId: $commentId) {
      ...mutationResponse
    }
  }
  ${FRAGMENT_MUTATION_RESPONSE}
`

export const MUTATION_UNDISMISS_COMMENT = gql`
  mutation engageUnDismiss($postId: String!, $commentId: String!) {
    engageUnDismiss(postId: $postId, commentId: $commentId) {
      ...mutationResponse
    }
  }
  ${FRAGMENT_MUTATION_RESPONSE}
`

export const MUTATION_DISMISS_ALL = gql`
  mutation engageDismissAll($type: String!, $targetId: String!) {
    engageDismissAll(type: $type, targetId: $targetId) {
      code
      success
    }
  }
`
